export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    type: 'seq',
    fixed: 'left',
  },
  {
    field: 'checkbox',
    width: 60,
    align: 'center',
    fixed: 'left',
    type: 'checkbox',
  },
  {
    title: that.$l('INDEX.table_label_image') || '图片',
    field: 'defaultImageUrl',
    headerAlign: 'center',
    align: 'left',
    fixed: 'left',
    width: 80,
    slots: { default: 'defaultImageUrl' },
  },
  {
    title: that.$l('table_label_displayName') || '产品名称',
    field: 'goodsName',
    headerAlign: 'center',
    align: 'left',
    fixed: 'left',
    minWidth: 220,
    slots: { default: 'displayName' },
  },
  {
    title: that.$l('table_label_displayNo') || '产品编号',
    field: 'amzSkuNo',
    headerAlign: 'center',
    align: 'left',
    minWidth: 180,
    slots: { default: 'displayNo' },
  },
  {
    title: that.$l('table_label_materialInfo') || '材质',
    field: 'materialInfo',
    minWidth: 240,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    slots: { default: 'displayMaterialInfoName' },
  },
  {
    title: that.$l('table_label_collectionName') || '系列',
    field: 'collectionName',
    width: 100,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
  },

  {
    title: that.$l('table_label_lastShipmentDate') || '最后一次出货时间',
    field: 'lastShipmentDate',
    width: 150,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_poNo') || '合同号',
    field: 'poNo',
    align: 'center',
    minWidth: 140,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_ftyPrice') || '单价',
    field: 'ftyPrice',
    align: 'center',
    minWidth: 140,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_scmName') || '工厂',
    field: 'scmName',
    minWidth: 200,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayFactory' },
  },
  {
    title: that.$l('table_label_importanceLevel') || '新品/翻单',
    field: 'v_importanceLevel',
    minWidth: 100,
    headerAlign: 'left',
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_invQty') || '可出货库存数量',
    field: 'totalInvQty',
    align: 'center',
    minWidth: 150,
    showHeaderOverflow: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_totalActualQty') || '实际库存数量',
    field: 'totalActualQty',
    align: 'center',
    minWidth: 150,
    showHeaderOverflow: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_totalAmount') || '总金额',
    field: 'totalAmount',
    align: 'center',
    minWidth: 150,
    isTotalColumn: true,
    showHeaderOverflow: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_totalCtnCbm') || '总体积',
    field: 'totalCtnCbm',
    align: 'center',
    minWidth: 150,
    isTotalColumn: true,
    showHeaderOverflow: true,
    formatter: ({ cellValue }) => that.format(that.round(cellValue, 2)),
  },
  {
    title: that.$l('table_label_purchaseDate') || '采购下单时间',
    field: 'purchaseDate',
    align: 'center',
    minWidth: 100,
    showHeaderOverflow: true,
  },
  {
    title: that.$l('form_label_deliveryDate') || '工厂订单交期',
    field: 'deliveryDate',
    align: 'center',
    minWidth: 130,
    showHeaderOverflow: true,
  },
]
